import React from 'react';
import { Result, Button } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';

const EnvioInformeResultPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { status, message, subTitle, returnUrl } = location.state || {
        status: 'info',
        message: 'Página de resultado',
        subTitle: '',
        returnUrl: '/procesos'
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
            <Result
                status={status}
                title={message}
                subTitle={subTitle}
                extra={[
                    <Button type="primary" key="console" onClick={() => navigate(returnUrl)}>
                        Volver al Proceso
                    </Button>
                ]}
            />
        </div>
    );
};

export default EnvioInformeResultPage;
